// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography(theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12
        },
        h1: {
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.75rem' // 28px for mobile (default is 38px)
          }
        },
        h2: {
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.5rem' // 24px for mobile (default is 30px)
          }
        },
        h3: {
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.25rem' // 20px for mobile (default is 24px)
          }
        },
        h4: {
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.0rem' // 16px for mobile (default is 20px)
          }
        }
      }
    }
  };
}
